function showYesNo() {
  var checkbox = document.getElementById("website");
  var yesNoSection = document.getElementById("yesNoSection");

  // Toggle visibility based on checkbox checked state
  if (checkbox.checked) {
    yesNoSection.style.display = "block";
  } else {
    yesNoSection.style.display = "none";
  }
}
